import common from './common.json'
import arrival from './arrival.json';
import departure from './departure.json';
import cars from './cars.json';
import payment from './payment.json';
import car from './car.json';
import login from './login.json';
import register from './register.json';
import verification from './verification.json';
import errors from './errors.json';
import booking from './booking.json';
import policy from './policy.json';
import forgot from './forgot.json';

export default {
	common,
	arrival,
	departure,
	cars,
	payment,
	car,
	login,
	register,
	verification,
	errors,
	booking,
	policy,
	forgot
};
